// The assessment needs a planning statement to run; every other category is supporting evidence the model also reads.
export const STATEMENT_CATEGORY = 'Planning Statement';

// A site location plan: used to place the site boundary on the Locate map, not as assessment text.
export const LOCATION_PLAN_CATEGORY = 'Location Plan';

export const DOCUMENT_CATEGORIES = [
  STATEMENT_CATEGORY,
  'Design & Access Statement',
  'Flood Risk Assessment',
  'Ecology & Biodiversity',
  'Transport & Highways',
  'Heritage',
  'Arboricultural',
  LOCATION_PLAN_CATEGORY,
  'Other',
] as const;

export const DEFAULT_SUPPORTING_CATEGORY = 'Other';
